<template>
  <svg
    aria-hidden="true"
    class="inline-block self-center overflow-hidden fill-current stroke-current stroke-0"
    :class="[classSize]"
  >
    <use :xlink:href="`${symbolDefs}#icon-${name}`" :fill="color" />
  </svg>
</template>

<script setup lang="ts">
import symbolDefs from '~/assets/images/icons/symbol-defs.svg'

export type IconName =
  | 'arrow-down'
  | 'arrow-left'
  | 'arrow-right'
  | 'arrow-up'
  | 'chevron-down-filled'
  | 'chevron-down'
  | 'chevron-left-filled'
  | 'chevron-right'
  | 'chevron-right-filled'
  | 'chevron-up-filled'
  | 'chevron-up'
  | 'check'
  | 'close'
  | 'facebook'
  | 'instagram'
  | 'linkedin'
  | 'mail'
  | 'menu'
  | 'twitter'
  | 'youtube'
  | 'x'
  | 'tik-tok'
  | 'discord'

export type IconSize = '2xs' | 'xs' | 'sm' | 'md' | 'lg' | 'xl' | '2xl'

interface Props {
  color?: string | null
  name: IconName
  size?: IconSize
}

const props = withDefaults(defineProps<Props>(), {
  size: 'md',
  color: null
})

const classSize = computed(() => {
  let classList
  switch (props.size) {
    case '2xs':
      classList = 'w-3 h-3'
      break
    case 'xs':
      classList = 'w-4 h-4'
      break
    case 'sm':
      classList = 'w-5 h-5'
      break
    case 'lg':
      classList = 'w-8 h-8'
      break
    case 'xl':
      classList = 'w-10 h-10'
      break
    case '2xl':
      classList = 'w-16 h-16'
      break
    default:
      classList = 'w-6 h-6'
  }
  return classList
})
</script>
